import { HSLColor } from '@yola/yola-palette-generator';
import reduceColorPointByStep from '../utils/reduce-color-point-by-step';

const linkRuleHover = (params) => {
  const { targetColor, targetColorPalette, whiteColor, blackColor } = params;
  const fallback = {
    rule: 'link.hover.light',
    params,
  };
  if (whiteColor.equals(targetColor) || blackColor.equals(targetColor)) {
    const { hue, saturation, lightness } = targetColor;
    return new HSLColor(hue, saturation, lightness, 0.4);
  }
  return reduceColorPointByStep({ targetColor, targetColorPalette, step: 1, fallback });
};

export default linkRuleHover;
